import { createVNode as i, mergeProps as n } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ArrowRightOutlined.js";
import m from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return i(m, n(e, {
    icon: l
  }), null);
};
r.displayName = "ArrowRightOutlined";
r.inheritAttrs = !1;
export {
  r as default
};
